import React, { useEffect, useState } from 'react'

const initialsOf = name => (name || '?').replace(/^@/, '').slice(0, 2).toUpperCase()

export default function CreatorAvatar({ src, name, className = 'h-10 w-10 rounded-full', textClassName = 'text-sm' }) {
  const [failed, setFailed] = useState(false)

  useEffect(() => setFailed(false), [src])

  if (!src || failed) {
    return (
      <div className={`${className} flex items-center justify-center bg-rb-soft-green dark:bg-rb-green/15 text-rb-green font-semibold ${textClassName}`}>
        {initialsOf(name)}
      </div>
    )
  }

  return <img src={src} alt={name || 'avatar'} loading="lazy" onError={() => setFailed(true)} className={`${className} object-cover`} />
}
